import {Notification} from 'element-ui'
import {constantRouterMap} from '@/router'
var allRouter = new Set()
export function checkRouter (route) {
  // 处理一下路由带参数的
  let routeParams = getUrlkey(route)
  if (route && route.indexOf('?') !== -1) route = route.split('?')[0]
  // 底下是push，先清空保险一点
  allRouter.clear()
  loopGetAllRoute(constantRouterMap)
  if (allRouter.has(route)) {
    if (route === '/pageCustomi/pageCustomiDetail') { // 这里在判断下定制页面两个参数为必填
      if (routeParams && routeParams.tip && routeParams.httpUrl) {
        return true
      } else {
        Notification.error({
          title: '配置异常',
          message: '请联系管理员进行有效配置'
        });
      }
    } else {
      return true
    }
  } else {
    Notification.error({
      title: '温馨提示',
      message: '该跳转路径为无效路径，请联系管理员进行有效配置（' + route + '）'
    });
  }
}

// 获取全部的有效路由
function loopGetAllRoute (routeArr) {
  routeArr.forEach(item => {
    if (item.children) {
      allRouter.add(item.path)
      loopGetAllRoute(item.children)
    } else {
      allRouter.add(item.path)
    }
  })
}

// 解析Url参数
export function getUrlkey(url) {
  if (url && url.indexOf('?') !== -1) {
    var params = {};
    var urls = url.split("?")
    var arr = urls[1].split("&")
    for (var i = 0, l = arr.length; i < l; i++) {
      var a = arr[i].split("=")
      params[a[0]] = a[1]
    }
    return params
  } else {
    return false
  }
}

// 判断是否是外链
export function isHref (route) {
  if (route.indexOf('http:') !== -1 || route.indexOf('https:') !== -1) {
    window.open(route, '_blank')
    return true
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js